// actions/test-maintenance/reset.js

import { attachAuth } from '../../utils/authService';

export function resetHasErrored(bool) {
  return {
    type: 'RESET_TEST_M_HAS_ERRORED',
    hasErrored: bool
  };
}

export function resetIsLoading(bool) {
  return {
    type: 'RESET_TEST_M_IS_LOADING',
    isLoading: bool
  };
}

export function resetFetchDataSuccess(resp) {
  return {
    type: 'RESET_TEST_M_FETCH_DATA_SUCCESS',
    resp
  };
}

export function resetFetchData(host, body, reset) {
  return (dispatch) => {
    if (reset) {
      dispatch(resetFetchDataSuccess({}))
    }
    else {
      dispatch(resetIsLoading(true));
      dispatch(resetHasErrored(false));
      fetch(host + 'admin/reset', {
        method: 'post',
        body: JSON.stringify(body),
        headers: attachAuth()
      }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        dispatch(resetIsLoading(false));
        promise.json()
          .then(result => {
            dispatch(resetFetchDataSuccess(result))
          })
          .catch((e) => {
            console.log(e);
            dispatch(resetHasErrored(true))
          });
        })
        .catch((e) => {
          console.log(e);
            dispatch(resetIsLoading(false));
            dispatch(resetHasErrored(true));
        });
    }
  };
}